module.exports = __webpack_public_path__ + "static/media/downArrowIcon.d1479ad3.svg";